export function resolveAttachmentUrl(link: string, apiUrl: string): string {
  const apiOrigin = apiUrl.replace(/\/api\/?$/, '').replace(/\/$/, '');
  const url = new URL(link, `${apiOrigin}/`);
  if (['localhost', '127.0.0.1'].includes(url.hostname) && url.pathname.startsWith('/api/api/')) {
    url.pathname = url.pathname.slice('/api'.length);
  }
  return url.toString();
}
